import React from 'react'
import { motion } from "framer-motion";
import FadeInSectionDownToUp from '../../components/FadeAnimations/FadeInSectionDownToUp';
import ScrollableAircraftSection from '../../components/Fleet/ScrollableAircraftSection';

export default function OurFleet() {

    const fadeUp = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
    };

    return (
        <div>
            <div>
                <section className="relative w-full h-screen overflow-hidden flex items-center justify-center">
                    {/* Background Video */}
                    <video
                        className="absolute top-0 left-0 w-full h-full object-cover z-0"
                        src="https://mhcockpit.com/Media/4%20Aviators/Fleet/Flet-vdo.mp4" // Replace with your video URL
                        poster='https://mhcockpit.com/Media/4%20Aviators/Fleet/cover.jpg'
                        autoPlay
                        loop
                        muted
                    ></video>

                    {/* Dark overlay for better readability */}
                    <div className="absolute inset-0 bg-black/40 z-10"></div>

                    {/* Content */}
                    <motion.div
                        className="relative z-20 text-center px-6 max-w-4xl"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.2 }}
                        variants={fadeUp}
                    >
                        <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white mb-4">
                            Meet the Wings That Shape<br className='max-sm:hidden' /> Future <span className="text-[#FD9F27]">Aviators</span>
                        </h2>
                        <p className="text-white text-sm sm:text-base md:text-lg font-medium">
                            From simulators to real aircraft, our fleet is the foundation of every successful pilot we train.
                        </p>
                    </motion.div>
                </section>
            </div>
            <div className='text-center py-10'>
                <FadeInSectionDownToUp>
                    <p className='text-4xl font-bold'>Explore Our Fleet <span className='text-[#E43038]'>Gallery</span></p>
                    <p className='text-xl px-96 max-sm:px-5'>Discover the advanced training aircraft that power every flight at 4 Aviators  each model built for performance, safety, and precision in the skies.</p>
                </FadeInSectionDownToUp>
            </div>
            <div>
                <ScrollableAircraftSection />
            </div>
        </div>
    )
}
